import React, { useState, useRef, useEffect } from 'react';

const MODELS = [
  {
    key: 'negro',
    img: 'https://customer-assets-4nw71qhi.emergentagent.net/job_4cdae0ca-9c75-4bc0-a101-39471645aaff/artifacts/u81xj2pw_Eterna%20negro%202.png',
    name: 'ETERNA Black',
    subtitle: 'Negro Mate',
  },
  {
    key: 'blanco',
    img: 'https://customer-assets-4nw71qhi.emergentagent.net/job_4cdae0ca-9c75-4bc0-a101-39471645aaff/artifacts/mg9qown0_Eterna%20blanco%202.png',
    name: 'ETERNA White',
    subtitle: 'Blanco Perla',
  },
  {
    key: 'acero',
    img: 'https://customer-assets-4nw71qhi.emergentagent.net/job_4cdae0ca-9c75-4bc0-a101-39471645aaff/artifacts/l3bu03pn_Eterna%20acero%202.png',
    name: 'ETERNA Steel',
    subtitle: 'Acero Inoxidable',
  },
];

const ThreeModelsSection = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [hoveredModel, setHoveredModel] = useState(null);
  const [selectedModel, setSelectedModel] = useState(null);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const touchStartX = useRef(null);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); obs.disconnect(); } },
      { threshold: 0.1 }
    );
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);

  const getModelStyle = (i) => {
    if (hoveredModel === null) return { transform: 'translateY(0)', opacity: 1 };
    if (hoveredModel === i) return { transform: 'translateY(-16px)', opacity: 1 };
    return { transform: 'translateY(8px)', opacity: 0.45 };
  };

  const handleTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const handleTouchEnd = (e) => {
    if (!touchStartX.current) return;
    const delta = e.changedTouches[0].clientX - touchStartX.current;
    if (delta > 50 && carouselIndex > 0) setCarouselIndex(prev => prev - 1);
    if (delta < -50 && carouselIndex < 2) setCarouselIndex(prev => prev + 1);
    touchStartX.current = null;
  };

  return (
    <section
      id="diseno"
      ref={sectionRef}
      data-testid="three-models-section"
      style={{
        background: '#F5F5F7',
        padding: isMobile ? '80px 0' : '120px 48px',
        overflow: 'hidden',
      }}
    >
      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: '64px', padding: '0 24px' }}>
        <div
          className="section-label"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(30px)',
            transition: 'opacity 700ms ease-out, transform 700ms ease-out',
          }}
        >
          Acabados
        </div>
        <h2
          style={{
            fontFamily: 'Inter, sans-serif', fontWeight: 700,
            fontSize: 'clamp(28px, 4vw, 56px)',
            letterSpacing: '-0.02em', color: '#0A0A0A',
            marginBottom: '16px',
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(30px)',
            transition: 'opacity 700ms ease-out 100ms, transform 700ms ease-out 100ms',
            willChange: 'transform',
          }}
        >
          Tres acabados. Una sola filosofía.
        </h2>
        <p
          style={{
            fontFamily: 'Inter, sans-serif', fontWeight: 300, fontSize: '16px',
            color: '#6B6B6B',
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(30px)',
            transition: 'opacity 700ms ease-out 200ms, transform 700ms ease-out 200ms',
          }}
        >
          Edición Limitada — 999 unidades.
        </p>
      </div>

      {/* Desktop: 3 columns */}
      {!isMobile && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '48px', maxWidth: '1200px', margin: '0 auto' }}>
          {MODELS.map((model, i) => (
            <div
              key={model.key}
              className="model-card"
              onClick={() => setSelectedModel(selectedModel === i ? null : i)}
              onMouseEnter={() => setHoveredModel(i)}
              onMouseLeave={() => setHoveredModel(null)}
              style={{
                flex: 1,
                ...getModelStyle(i),
                transition: 'transform 400ms cubic-bezier(0.25,0.46,0.45,0.94), opacity 400ms cubic-bezier(0.25,0.46,0.45,0.94)',
                opacity: visible ? (hoveredModel !== null && hoveredModel !== i ? 0.45 : 1) : 0,
                transform: visible ? getModelStyle(i).transform : 'translateY(30px)',
                background: 'transparent',
              }}
              data-testid={`model-card-${model.key}`}
            >
              <div className="product-halo" style={{ background: 'transparent' }}>
                <img
                  src={model.img}
                  alt={model.name}
                  style={{
                    width: '100%', height: '420px',
                    objectFit: 'contain',
                    objectPosition: 'center center',
                    mixBlendMode: 'multiply',
                    transition: 'transform 400ms ease',
                  }}
                />
              </div>
              <div style={{
                fontFamily: 'Inter, sans-serif', fontWeight: 400, fontSize: '14px',
                letterSpacing: '0.08em', color: '#0A0A0A', marginTop: '24px',
              }}>
                {model.name}
              </div>
              <div style={{
                fontFamily: 'Inter, sans-serif', fontWeight: 300, fontSize: '13px',
                color: '#6B6B6B', marginTop: '4px',
              }}>
                {model.subtitle}
              </div>
              <div className={`model-underline ${selectedModel === i ? 'active' : ''}`} />
            </div>
          ))}
        </div>
      )}

      {/* Mobile: carousel */}
      {isMobile && (
        <div
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
          style={{ overflow: 'hidden', position: 'relative' }}
          data-testid="models-carousel"
        >
          <div style={{
            display: 'flex',
            transform: `translateX(-${carouselIndex * 100}%)`,
            transition: 'transform 400ms ease',
          }}>
            {MODELS.map((model, i) => (
              <div key={model.key} style={{
                minWidth: '100%', padding: '0 40px',
                display: 'flex', flexDirection: 'column', alignItems: 'center',
              }}>
                <div className="product-halo" style={{ width: '80%', background: 'transparent' }}>
                  <img
                    src={model.img}
                    alt={model.name}
                    style={{ width: '100%', height: '420px', objectFit: 'contain', objectPosition: 'center center', mixBlendMode: 'multiply' }}
                  />
                </div>
                <div style={{
                  fontFamily: 'Inter, sans-serif', fontWeight: 400, fontSize: '14px',
                  letterSpacing: '0.08em', color: '#0A0A0A', marginTop: '24px',
                }}>
                  {model.name}
                </div>
                <div style={{
                  fontFamily: 'Inter, sans-serif', fontWeight: 300, fontSize: '13px',
                  color: '#6B6B6B', marginTop: '4px',
                }}>
                  {model.subtitle}
                </div>
              </div>
            ))}
          </div>
          {/* Carousel dots */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '32px' }}>
            {[0, 1, 2].map(i => (
              <button
                key={i}
                onClick={() => setCarouselIndex(i)}
                style={{
                  width: '6px', height: '6px', borderRadius: '50%',
                  background: carouselIndex === i ? '#0A0A0A' : '#E8E6E0',
                  border: 'none', cursor: 'pointer', padding: 0,
                  transition: 'background 300ms ease',
                }}
              />
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default ThreeModelsSection;
